<template>
  <div class="d-pc-shop_search-content" v-r-loading="loading">
    <div
      class="shop-name finger-style"
      v-for="(item, index) in words"
      :key="index"
      @click="handleSelect(item, index)"
    >
      <div class="shop-name_box two-ellipsis">
        {{ item }}
      </div>
    </div>
    <div v-if="loading"></div>
    <NoList v-else-if="isH5 && !(words && words.length)"></NoList>
    <NoList v-else-if="!isH5 && !(words && words.length)" imgTop="-15px"></NoList>
  </div>
</template>
<script>
import NoList from '../NoList';
export default {
  components: {
    NoList,
  },
  props: {
    isH5:Boolean,
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
    words: {
      type: Array,
      default: () => [],
      required: false,
    },
    input_word: {
      type: String,
      default: '',
      required: false,
    },
  },
  methods: {
    handleSelect(item, sug_index) {
      this.$emit('handleSelect', 3, item, sug_index);
    },
  },
};
</script>
<style lang="scss">
.d-pc-shop_search-content {
  padding-top: 4px;
  height: 280px;
  overflow-y: auto;
  .shop-name {
    font-size: 14px;
    color: #000000;
    font-weight: 400;
  }
  .shop-name:last-child {
    .shop-name_box {
      border-bottom: none;
    }
  }
  .shop-name_box {
    margin-left: 16px;
    padding: 18px 61px 18px 0;
    border-bottom: 1px solid #e5e5e5;
    font-family: 'Aspira Light';
    font-size: 14px;
    line-height: 18px;
  }
  .shop-name:hover {
    background: #f5f5f7;
  }
}

@media screen and (max-width: 768px) {
  .d-pc-shop_search-content {
    .shop-name_box {
      margin-left: 0 !important;
      padding: rem(40) 0 !important;
      margin: 0 rem(18) !important;
      border-bottom: rem(2) solid #e5e5e5 !important;
      font-family: 'Aspira Medium' !important;
      font-size: rem(28) !important;
      line-height: rem(36) !important;
      color: #000000 !important;
      font-weight: 500 !important;
      overflow: hidden;
    }
  }
   .shop-name:last-child {
    .shop-name_box {
      border-bottom: none !important;
    }
  }
}
</style>
